@if (filterType == filterTypes.Text) {
  <input [attr.data-testid]="dataTestId" [(ngModel)]="data" pInputText type="text"
    placeholder="{{ placeHolder | translate}}" [className]="cssClass" (keydown)="searchNotPropagate($event)" (blur)="search()" (focus)="setDefault()" />
}

@if (filterType == filterTypes.Numeric) {
  <p-inputNumber [(ngModel)]="data"  [(ngModel)]="data"
    placeholder="{{ placeHolder | translate}}" [className]="cssClass" (keydown)="searchNotPropagate($event) " (onBlur)="search()" (onFocus)="setDefault()"/>
}

@if (filterType == filterTypes.Combo) {
  <app-custom-dropdown
    [attr.data-testid]="dataTestId"
    [options]="filterData"
    optionLabel="text"
    optionValue="id"
    [isMultiselect]="false"
    [showSelectionChips]="true"
    [showClear]="true"
    [searchMode]="'local'"
    [pageSize]="10"
    [placeholder]="placeHolder | translate"
    [(ngModel)]="data"
    (ngModelChange)="search()">
  </app-custom-dropdown>
}

@if (filterType == filterTypes.ComboAsync) {
  <app-custom-dropdown
    [attr.data-testid]="dataTestId"
    [options]="filterData"
    optionLabel="text"
    optionValue="id"
    [isMultiselect]="false"
    [showSelectionChips]="true"
    [showClear]="true"
    [searchMode]="'local'"
    [pageSize]="10"
    [placeholder]="placeHolder | translate"
    [(ngModel)]="data"
    (ngModelChange)="search()">
  </app-custom-dropdown>
}

@if (filterType == filterTypes.ComboCheckbox) {
  <app-custom-dropdown
    [attr.data-testid]="dataTestId"
    [options]="filterData"
    optionLabel="text"
    optionValue="id"
    [isMultiselect]="true"
    [showSelectionChips]="true"
    [showClear]="true"
    [compactUi]="false"
    [showSearchbox]="false"
    [searchMode]="'local'"
    [pageSize]="10"
    [placeholder]="placeHolder | translate"
    [(ngModel)]="data"
    (ngModelChange)="search()">
  </app-custom-dropdown>
}

@if (filterType == filterTypes.Date) {
  <p-datepicker [(ngModel)]="data" placeholder="{{ placeHolder | translate}}"  dateFormat="dd-mm-yy"
    [className]="cssClass" (onBlur)="search(true)" readonlyInput="true" [showClear]="true" appendTo="body" selectionMode="range" (onClear)="clear()"  />
}

@if (filterType == filterTypes.DateTime) {
  <p-datepicker [(ngModel)]="data" [showTime]="true" [hourFormat]="'24'"  dateFormat="dd-mm-yy"
    placeholder="{{ placeHolder | translate}}" [className]="cssClass" (onBlur)="search(true)" appendTo="body" (onClear)="clear()" />
}

@if (filterType == filterTypes.Time) {
  <p-datepicker [(ngModel)]="data" [timeOnly]="true"  dateFormat="dd-MM-yyyy"
    placeholder="{{ placeHolder | translate}}" [className]="cssClass" (onBlur)="search(true)" (onClear)="clear()" />
}
